define("calendar/components/calendar/settings/bttp/generate", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{! Show success message for all profiles except TikTok without rolloutBttpV3 flag }}
  {{#if (or (not this.isTiktok) @rolloutBttpV3)}}
    <p class="u--text--success" data-test-id="bttp-generate">
      {{svg-jar "verified" class="o--icon o--icon--success u--m__r__xs"}}
      {{t "bttp.reached_post_threshold"}}
    </p>
  {{/if}}
  
  <p class="u--text--light">
    {{#if (and this.isTiktok (not @rolloutBttpV3))}}
      {{html-safe (t "bttp.toggle_details")}}
      <Shared::Link @href={{this.learnMoreLink}} @text={{t "shared_phrases.learn_more"}} />
    {{else}}
      {{html-safe (t "bttp.toggle_details_2")}}
    {{/if}}
  </p>
  
  <Shared::Ui::Button @class="u--m__b" @onClick={{perform @triggerBttp true}} @variant="outline">
    {{svg-jar "bttp" class="o--icon u--m__r__xs"}}
    {{t "bttp.generate"}}
  </Shared::Ui::Button>
  
  {{#unless @isOnLegacyPlan}}
    <Calendar::Settings::Bttp::InfoCard />
  {{/unless}}
  */
  {
    "id": "C1Wwcn+z",
    "block": "[[[41,[28,[37,1],[[28,[37,2],[[30,0,[\"isTiktok\"]]],null],[30,1]],null],[[[1,\"  \"],[10,2],[14,0,\"u--text--success\"],[14,\"data-test-id\",\"bttp-generate\"],[12],[1,\"\\n    \"],[1,[28,[35,3],[\"verified\"],[[\"class\"],[\"o--icon o--icon--success u--m__r__xs\"]]]],[1,\"\\n    \"],[1,[28,[35,4],[\"bttp.reached_post_threshold\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[10,2],[14,0,\"u--text--light\"],[12],[1,\"\\n\"],[41,[28,[37,5],[[30,0,[\"isTiktok\"]],[28,[37,2],[[30,1]],null]],null],[[[1,\"    \"],[1,[28,[35,6],[[28,[37,4],[\"bttp.toggle_details\"],null]],null]],[1,\"\\n    \"],[8,[39,7],null,[[\"@href\",\"@text\"],[[30,0,[\"learnMoreLink\"]],[28,[37,4],[\"shared_phrases.learn_more\"],null]]],null],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,6],[[28,[37,4],[\"bttp.toggle_details_2\"],null]],null]],[1,\"\\n\"]],[]]],[13],[1,\"\\n\\n\"],[8,[39,8],null,[[\"@class\",\"@onClick\",\"@variant\"],[\"u--m__b\",[28,[37,9],[[30,2],true],null],\"outline\"]],[[\"default\"],[[[[1,\"\\n  \"],[1,[28,[35,3],[\"bttp\"],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n  \"],[1,[28,[35,4],[\"bttp.generate\"],null]],[1,\"\\n\"]],[]]]]],[1,\"\\n\\n\"],[41,[51,[30,3]],[[[1,\"  \"],[8,[39,11],null,null,null],[1,\"\\n\"]],[]],null]],[\"@rolloutBttpV3\",\"@triggerBttp\",\"@isOnLegacyPlan\"],false,[\"if\",\"or\",\"not\",\"svg-jar\",\"t\",\"and\",\"html-safe\",\"shared/link\",\"shared/ui/button\",\"perform\",\"unless\",\"calendar/settings/bttp/info-card\"]]",
    "moduleName": "calendar/components/calendar/settings/bttp/generate.hbs",
    "isStrictMode": false
  });
  let GenerateComponent = _exports.default = (_dec = (0, _service.inject)('calendar/bttp'), (_class = class GenerateComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor, this);
      _initializerDefineProperty(this, "bttp", _descriptor2, this);
    }
    get isTiktok() {
      return Boolean(this.selectedSocialProfiles?.firstProfile?.isTiktok);
    }
    get learnMoreLink() {
      return this.bttp.learnMoreLink(this.selectedSocialProfiles.firstProfile?.profileType);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bttp", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, GenerateComponent);
});